import type {
  PublicationFetchForTopicPayload,
  PublicationFetchForTopicSuccessAction,
} from "entities/publication/actionTypes";
import type { ErrorMeta } from "types/redux";

export enum KnowledgeDataActionTypes {
  FETCH_FOR_TOPIC = "entities/KNOWLEDGE_DATA_FETCH_FOR_TOPIC",
  FETCH_FOR_TOPIC_SUCCESS = "entities/KNOWLEDGE_DATA_FETCH_FOR_TOPIC_SUCCESS",
  FETCH_FOR_TOPIC_FAILURE = "entities/KNOWLEDGE_DATA_FETCH_FOR_TOPIC_FAILURE",
}

export type KnowledgeDataFetchForTopicPayload = Omit<PublicationFetchForTopicPayload, "language" | "publication_type">;

export type KnowledgeDataFetchForTopicAction = {
  meta: { forceRefresh?: boolean };
  payload: KnowledgeDataFetchForTopicPayload;
  type: KnowledgeDataActionTypes.FETCH_FOR_TOPIC;
};

export type KnowledgeDataFetchForTopicSuccessAction = Omit<PublicationFetchForTopicSuccessAction, "type"> & {
  type: KnowledgeDataActionTypes.FETCH_FOR_TOPIC_SUCCESS;
};

type KnowledgeDataFetchForTopicFailureMeta = ErrorMeta & { searchCriteria: PublicationFetchForTopicPayload };

export type KnowledgeDataFetchForTopicFailureAction = {
  meta: KnowledgeDataFetchForTopicFailureMeta;
  type: KnowledgeDataActionTypes.FETCH_FOR_TOPIC_FAILURE;
};

export type KnowledgeDataAction =
  | KnowledgeDataFetchForTopicAction
  | KnowledgeDataFetchForTopicSuccessAction
  | KnowledgeDataFetchForTopicFailureAction;
